module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box info-box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._v("\n        Search By\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Branch"
    }
  }, [_vm._v("Branch")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "branch_id",
      "label": "name",
      "options": _vm.branches,
      "placeholder": "Select Branch"
    },
    on: {
      "input": function($event) {
        return _vm.getBranchRecord(_vm.branch)
      }
    },
    model: {
      value: (_vm.branch),
      callback: function($$v) {
        _vm.branch = $$v
      },
      expression: "branch"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Branch"
    }
  }, [_vm._v("Member (Type Here)")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "member_id",
      "filterable": false,
      "label": "name",
      "options": _vm.members,
      "placeholder": "Select Member"
    },
    on: {
      "search": _vm.getMemberRecords,
      "input": _vm.getRecordMemberWise
    },
    model: {
      value: (_vm.member),
      callback: function($$v) {
        _vm.member = $$v
      },
      expression: "member"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "staff_id"
    }
  })], 1)])])]), _vm._v(" "), (_vm.canAccess('loan-disbursement-view-any')) ? _c('div', {
    staticClass: "info-box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Loan Topup List")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [(_vm.canAccess('loan-disbursement-create-loan')) ? _c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.newModalTopup
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add New\n          ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-6"
  }, [_c('label', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.per_page),
      expression: "per_page"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "name": "per_page",
      "aria-controls": "example1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.per_page = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeFilter()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("25")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("100")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-6"
  }, [_c('div', {
    staticClass: "input-group pull-right input-group-sm",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.table_search),
      expression: "table_search"
    }],
    staticClass: "form-control pull-right",
    attrs: {
      "type": "text",
      "name": "table_search",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.table_search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.changeFilter()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.table_search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeFilter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-sm table-bordered table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.rows), function(row, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s((index + _vm.pagination.from)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.new_loan_amt))]), _vm._v(" "), _c('td', [(row.member) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.viewMemberAddDetail(row.member_id)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(row.member.name) + " (" + _vm._s(row.member.code) + ")\n                    ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.branch.name) + " (" + _vm._s(row.branch.branchCode) + ")")]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.previous_member_loan_plan.applicationNo))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.previous_loan_amt))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.previous_due_amt))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.previous_loan_due_principal_amt))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.previous_loan_due_interest_amt))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.previous_loan_forclose_charges))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.previous_loan_discount))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [(row.created_by) ? _c('span', [_vm._v(_vm._s(row.created_by.name) + " (" + _vm._s(row.created_by.code) + ")")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.status))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "btn-group"
    }, [_vm._m(1, true), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu dropdown-menu-right",
      attrs: {
        "role": "menu"
      }
    }, [(_vm.canAccess('loan-disbursement-create') && row.status === 'pending') ? _c('li', [_c('a', {
      attrs: {
        "title": "Loan Topup Approve"
      },
      on: {
        "click": function($event) {
          return _vm.applyTopupApprove(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-leanpub"
    }), _vm._v(" Loan Topup Approve\n                        ")])]) : _vm._e(), _vm._v(" "), _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.filechargeStatus == 'exclude'),
        expression: "row.filechargeStatus == 'exclude'"
      }]
    }, [_c('a', {
      attrs: {
        "title": "File Charge"
      },
      on: {
        "click": function($event) {
          return _vm.fileChargeModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file"
    }), _vm._v(" File Charge\n                        ")])]), _vm._v(" "), _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.processingFeeStatus == 'exclude'),
        expression: "row.processingFeeStatus == 'exclude'"
      }]
    }, [_c('a', {
      attrs: {
        "title": "Processing Fee"
      },
      on: {
        "click": function($event) {
          return _vm.processingFeeModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-hourglass"
    }), _vm._v(" Processing Fee\n                        ")])]), _vm._v(" "), _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.insuranceFeeStatus == 'exclude'),
        expression: "row.insuranceFeeStatus == 'exclude'"
      }]
    }, [_c('a', {
      attrs: {
        "title": "Insurance Fee"
      },
      on: {
        "click": function($event) {
          return _vm.insuranceFeeModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-user-md"
    }), _vm._v(" Insurance Fee\n                        ")])]), _vm._v(" "), (_vm.canAccess('loan-disbursement-view')) ? _c('li', [_c('a', {
      attrs: {
        "title": "View"
      },
      on: {
        "click": function($event) {
          return _vm.viewTopupRecord(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-money"
    }), _vm._v(" View\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('loan-disbursement-delete')) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.deleteTopup(row.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Delete\n                        ")])]) : _vm._e()])])])])
  }), 0)])])]), _vm._v(" "), (_vm.pagination.current_page > 0) ? _c('div', {
    staticClass: "box-footer clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("\n            Showing " + _vm._s(_vm.pagination.from) + " to " + _vm._s(_vm.pagination.to) + " of " + _vm._s(_vm.pagination.total) + " entries\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('ul', {
    staticClass: "pagination pagination-sm no-margin pull-right"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'first')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("«")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'prev')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Prev")])]), _vm._v(" "), (_vm.pagination.current_page > 3) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 2) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 1) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "active",
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page))])]), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 4)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 1))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 5)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 6)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 3))])]) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 3)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 2)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 1)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page))])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'next')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Next")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'last')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("»")])])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "newModalTopup"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(3), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editMode),
      expression: "!editMode"
    }],
    staticClass: "modal-title"
  }, [_vm._v("Add New")]), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode),
      expression: "editMode"
    }],
    staticClass: "modal-title"
  }, [_vm._v("Update")])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.editMode ? _vm.updateLoan() : _vm.createTopup()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_id),
      expression: "form.branch_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_id'),
    },
    attrs: {
      "name": "branch_id",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.getMemberAndGroupAndAgent]
    }
  }, [(!_vm.form.branch_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                              Select Branch\n                            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.branches), function(bra) {
    return _c('option', {
      key: bra.id,
      domProps: {
        "value": bra.id
      }
    }, [_vm._v("\n                              " + _vm._s(bra.name) + "\n                            ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "member_id",
      "label": "name",
      "options": _vm.members,
      "placeholder": "Select Member"
    },
    on: {
      "input": _vm.getBranchMember
    },
    model: {
      value: (_vm.mem),
      callback: function($$v) {
        _vm.mem = $$v
      },
      expression: "mem"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "member_id"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.memberloanplans.length > 0) ? _c('table', {
    staticClass: "table table-sm table-bordered table-hover"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm.memberloanplans), function(mlp, id) {
    return _c('tr', {
      key: id
    }, [_c('td', {
      staticClass: "hidden-xs"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.previous_member_loan_plan_id),
        expression: "form.previous_member_loan_plan_id"
      }],
      staticClass: "minimal",
      attrs: {
        "type": "radio",
        "name": "previous_member_loan_plan_id"
      },
      domProps: {
        "value": mlp.id,
        "checked": _vm._q(_vm.form.previous_member_loan_plan_id, mlp.id)
      },
      on: {
        "change": [function($event) {
          return _vm.$set(_vm.form, "previous_member_loan_plan_id", mlp.id)
        }, function($event) {
          return _vm.getLoanEMI(mlp)
        }]
      }
    })]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Application No :")]), _vm._v(" " + _vm._s(mlp.applicationNo) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Plan Name : ")]), _vm._v(" " + _vm._s(_vm.getPlanDetails(mlp.disbursement.plan, 'name')) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Plan Type : ")]), _vm._v(" " + _vm._s(_vm.getPlanDetails(mlp.disbursement.plan, 'planType')) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Type :")]), _vm._v(" " + _vm._s(mlp.type) + " "), _c('br'), _vm._v(" "), (mlp.collection_center_id) ? _c('i', [_c('strong', [_vm._v("Group :")]), _vm._v(_vm._s(mlp.collection_center.name) + " (" + _vm._s(mlp.collection_center.centerCode) + ") "), _c('br')]) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v("Branch : ")]), _vm._v(_vm._s(mlp.branch.name) + "\n                                ")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Payable Amount : ")]), _vm._v(_vm._s(mlp.totalAmt) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Plan Amount : ")]), _vm._v(" " + _vm._s(_vm.getPlanDetails(mlp.disbursement.plan, 'loanAmount')) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Disbursement Amount : ")]), _vm._v(" " + _vm._s(_vm.getPlanDetails(mlp.disbursement.plan, 'disbursementAmount')) + " "), _c('br'), _vm._v(" "), _c('strong', {
      staticClass: "text-success"
    }, [_vm._v("Paid Amount : ")]), _vm._v(_vm._s(mlp.receivedAmt)), _c('br'), _vm._v(" "), _c('strong', {
      staticClass: "text-danger"
    }, [_vm._v("Due Amount : ")]), _vm._v(_vm._s(mlp.totalAmt - mlp.receivedAmt)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Received Penalty : ")]), _vm._v(" " + _vm._s(mlp.receivedPanulty) + "\n                                ")]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_c('strong', [_vm._v("Disbursement : ")]), _vm._v(_vm._s(_vm._f("myDate")(mlp.disbursement.disbursementDate))), _c('br'), _vm._v(" "), _c('strong', [_vm._v("First EMI : ")]), _vm._v(_vm._s(_vm._f("myDate")(mlp.disbursement.emiStartDate))), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Last EMI : ")]), _vm._v(_vm._s(_vm._f("myDate")(mlp.disbursement.emiEndDate)) + "\n                                ")])])
  }), 0)]) : _vm._e(), _vm._v(" "), _vm._m(7), _vm._v(" "), (_vm.memberEMIs.length > 0) ? _c('table', {
    staticClass: "table table-sm table-bordered table-hover"
  }, [_vm._m(8), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.form.previous_no_of_emi))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.form.previous_paid_no_of_emi))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.form.previous_due_no_of_emi))])])])]) : _vm._e()]), _vm._v(" "), (_vm.memberEMIs.length > 0) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', [_c('strong', [_vm._v("Due Principal Amount : ")]), _vm._v(" " + _vm._s(_vm.form.previous_loan_due_principal_amt) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Due Interest Amount : ")]), _vm._v(" " + _vm._s(_vm.form.previous_loan_due_interest_amt) + " "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Amount : ")]), _vm._v(" " + _vm._s(_vm.paybleAmt) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Amount With Forclose Charge : ")]), _vm._v(" " + _vm._s(_vm.paybleAmtWithForCloseCharge) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Payable Amount With Discount : ")]), _vm._v(" " + _vm._s(_vm.paybleAmtWithDiscount) + "\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.memberEMIs.length > 0) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(9), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.previous_loan_forclose_charges),
      expression: "form.previous_loan_forclose_charges"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('previous_loan_forclose_charges'),
    },
    attrs: {
      "type": "number",
      "name": "previous_loan_forclose_charges",
      "placeholder": "Enter For Close Charges",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.previous_loan_forclose_charges)
    },
    on: {
      "change": _vm.getPaybleAmount,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "previous_loan_forclose_charges", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "previous_loan_forclose_charges"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(10), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.previous_loan_discount),
      expression: "form.previous_loan_discount"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('previous_loan_discount'),
    },
    attrs: {
      "type": "text",
      "name": "previous_loan_discount",
      "placeholder": "Write Off Interest Amount",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.previous_loan_discount)
    },
    on: {
      "change": _vm.getPaybleAmount,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "previous_loan_discount", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "previous_loan_discount"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(11), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.new_loan_amt),
      expression: "form.new_loan_amt"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('new_loan_amt'),
    },
    attrs: {
      "type": "text",
      "name": "new_loan_amt",
      "placeholder": "Write Off Interest Amount",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.new_loan_amt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "new_loan_amt", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "new_loan_amt"
    }
  })], 1)]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editMode),
      expression: "!editMode"
    }],
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                CREATE\n              ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode),
      expression: "editMode"
    }],
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                UPDATE\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                CANCEL\n              ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "newModalLoan"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(12), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editMode),
      expression: "!editMode"
    }],
    staticClass: "modal-title"
  }, [_vm._v("Apply For Loan Topup Approve")]), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode),
      expression: "editMode"
    }],
    staticClass: "modal-title"
  }, [_vm._v("Update Loan")])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.editMode ? _vm.updateLoan() : _vm.createLoan()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(13), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "branch_center_id",
      "label": "name",
      "options": _vm.branchcenters,
      "placeholder": "Select Staff"
    },
    on: {
      "input": _vm.branchCenterWiseRecord
    },
    model: {
      value: (_vm.branchcenter),
      callback: function($$v) {
        _vm.branchcenter = $$v
      },
      expression: "branchcenter"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_center_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(14), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "agent_id",
      "label": "name",
      "options": _vm.staffs,
      "placeholder": "Select Staff"
    },
    on: {
      "input": _vm.getBranchAgent
    },
    model: {
      value: (_vm.staf),
      callback: function($$v) {
        _vm.staf = $$v
      },
      expression: "staf"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "agent_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(15), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "purpose",
      "label": "name",
      "placeholder": "Select purpose",
      "options": _vm.purposes
    },
    on: {
      "input": _vm.getSelectPurpose
    },
    model: {
      value: (_vm.form.purpose),
      callback: function($$v) {
        _vm.$set(_vm.form, "purpose", $$v)
      },
      expression: "form.purpose"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "purpose_id"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.purpose_id),
      expression: "form.purpose_id"
    }],
    attrs: {
      "type": "hidden",
      "name": "purpose_id"
    },
    domProps: {
      "value": (_vm.form.purpose_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "purpose_id", $event.target.value)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(16), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "plan",
      "label": "name",
      "placeholder": "Select Plan",
      "options": _vm.loanplans
    },
    on: {
      "input": _vm.getSelectPlan
    },
    model: {
      value: (_vm.form.plan),
      callback: function($$v) {
        _vm.$set(_vm.form, "plan", $$v)
      },
      expression: "form.plan"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "plan_id"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.plan_id),
      expression: "form.plan_id"
    }],
    attrs: {
      "type": "hidden",
      "name": "plan_id"
    },
    domProps: {
      "value": (_vm.form.plan_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "plan_id", $event.target.value)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(17), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.description),
      expression: "form.description"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('description'),
    },
    attrs: {
      "type": "text",
      "name": "description",
      "placeholder": "Enter Description"
    },
    domProps: {
      "value": (_vm.form.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "description"
    }
  })], 1), _vm._v(" "), (_vm.form.planType == 'individual') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Guarantor ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "guarantor_id",
      "label": "name",
      "options": _vm.members,
      "placeholder": "Select Member"
    },
    on: {
      "input": _vm.getLoanGuarantor
    },
    model: {
      value: (_vm.guarantor),
      callback: function($$v) {
        _vm.guarantor = $$v
      },
      expression: "guarantor"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "guarantor_id"
    }
  })], 1) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editMode),
      expression: "!editMode"
    }],
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                CREATE\n              ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode),
      expression: "editMode"
    }],
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                UPDATE\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                CANCEL\n              ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "disbursmentModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(18), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createDisbursement()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(19), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.disbursementDate),
      expression: "form.disbursementDate"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'disbursementDate'
      ),
    },
    attrs: {
      "type": "date",
      "name": "disbursementDate",
      "placeholder": "Enter joining Date",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.disbursementDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "disbursementDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "disbursementDate"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.disbursement_id),
      expression: "form.disbursement_id"
    }],
    attrs: {
      "type": "hidden",
      "name": "disbursement_id"
    },
    domProps: {
      "value": (_vm.form.disbursement_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "disbursement_id", $event.target.value)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(20), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.emiStartDate),
      expression: "form.emiStartDate"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('emiStartDate'),
    },
    attrs: {
      "type": "date",
      "name": "emiStartDate",
      "placeholder": "Enter joining Date",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.emiStartDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "emiStartDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "emiStartDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Ledger Account ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_ledger_id),
      expression: "form.branch_ledger_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_ledger_id'),
    },
    attrs: {
      "name": "branch_ledger_id"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_ledger_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.branch_ledger_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                              Select Ledger Account\n                            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.bank_accounts), function(bank_account) {
    return _c('option', {
      key: bank_account.id,
      domProps: {
        "value": bank_account.id
      }
    }, [_vm._v("\n                              " + _vm._s(bank_account.name) + " " + _vm._s(bank_account.remark) + "\n                            ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_ledger_id"
    }
  })], 1)])])])])]), _vm._v(" "), _vm._m(21)])])])]), _vm._v(" "), _c('view-loan-plan', {
    attrs: {
      "seeRecord": this.seeRecord,
      "pl": this.pl,
      "memberDetail": this.memberDetail,
      "getCompanyRecord": this.getCompanyRecord,
      "logo": this.logo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [(_vm.seeRecord.branch) ? _c('ul', {
    staticClass: "list-group list-group-unbordered mb-3"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Branch Name")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.branch.name))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Branch Code")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.branch.branchCode))])]), _vm._v(" "), (_vm.seeRecord.member_id) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Member Name")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.member.name))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("PREVIOUS LOAN PLAN DETAILS")]), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-striped table-dark"
  }, [_c('tr', [_c('td', [_c('b', [_vm._v("Plan Name ")]), _vm._v(" : " + _vm._s(_vm.pl.name))])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Plan Type ")]), _vm._v(" : " + _vm._s(_vm.pl.planType))])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Type of Interest")]), _vm._v(" : " + _vm._s(_vm.pl.typeOfInterest) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Recovery Type")]), _vm._v(" : " + _vm._s(_vm.pl.recoveryType) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Number of Payments")]), _vm._v(" :\n                              " + _vm._s(_vm.pl.noOfPayments) + "\n                            ")])])])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("New Loan Amount")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.new_loan_amt))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Create At")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.created_at))])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [(_vm.seeRecord.branch) ? _c('ul', {
    staticClass: "list-group list-group-unbordered mb-3"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("PREVIOUS LOAN DETAILS")]), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-striped table-dark"
  }, [_c('tr', [_c('td', [_c('b', [_vm._v("Loan Application No. ")]), _vm._v(" : " + _vm._s(_vm.seeRecord.previous_member_loan_plan.applicationNo))])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Due No Of EMI")]), _vm._v(" : " + _vm._s(_vm.seeRecord.previous_due_no_of_emi) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("First EMI Date")]), _vm._v(" : " + _vm._s(_vm.seeRecord.previous_disbursement.emiStartDate) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Last EMI Date")]), _vm._v(" : " + _vm._s(_vm.seeRecord.previous_disbursement.emiEndDate) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Loan Total Amount")]), _vm._v(" : " + _vm._s(_vm.seeRecord.previous_loan_amt) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Loan Principal Amount")]), _vm._v(" : " + _vm._s(_vm.seeRecord.previous_principal_amt) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Loan Interest Amount")]), _vm._v(" : " + _vm._s(_vm.seeRecord.previous_interest_amt) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Loan Due Amount")]), _vm._v(" : " + _vm._s(_vm.seeRecord.previous_due_amt) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Loan Due Principal Amount")]), _vm._v(" : " + _vm._s(_vm.seeRecord.previous_loan_due_principal_amt) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Loan Due Interest Amount")]), _vm._v(" : " + _vm._s(_vm.seeRecord.previous_loan_due_interest_amt) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Loan Forclose Charges")]), _vm._v(" : " + _vm._s(_vm.seeRecord.previous_loan_forclose_charges) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Loan Interest Write Off Amount")]), _vm._v(" : " + _vm._s(_vm.seeRecord.previous_loan_discount) + "\n                            ")])])])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Status")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.status))])])]) : _vm._e()])])])])]), _vm._v(" "), _vm._m(23)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewGroupMember"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(24), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('ul', {
    staticClass: "list-group list-group-unbordered mb-3"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(25), _vm._v(" "), _c('tbody', [(_vm.groupmem) ? _c('tr', [_c('td', [_vm._v("\n                              " + _vm._s(_vm.groupmem.fatherName) + "\n                            ")]), _vm._v(" "), _c('td', [_vm._v("\n                              " + _vm._s(_vm.groupmem.address) + "\n                            ")]), _vm._v(" "), _c('td', [_vm._v("\n                              " + _vm._s(_vm.groupmem.city) + "\n                            ")])]) : _vm._e()])])])])])])])]), _vm._v(" "), _vm._m(26)])])]), _vm._v(" "), _c('demandprobeshnarynote', {
    attrs: {
      "seeRecord": _vm.seeRecord,
      "getCompanyRecord": _vm.getCompanyRecord,
      "logo": _vm.logo,
      "pl": _vm.pl,
      "mem": _vm.mem
    }
  }), _vm._v(" "), _c('aadharagreementletter', {
    attrs: {
      "seeRecord": _vm.seeRecord,
      "getCompanyRecord": _vm.getCompanyRecord,
      "logo": _vm.logo,
      "pl": _vm.pl,
      "mem": _vm.mem
    }
  }), _vm._v(" "), _c('previousloanrecord', {
    attrs: {
      "seeRecord": _vm.seeRecord,
      "getCompanyRecord": _vm.getCompanyRecord,
      "memberloanplans": _vm.memberloanplans,
      "logo": _vm.logo
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "background-color": "#d6dddd"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Sr.")]), _vm._v(" "), _c('th', [_vm._v("Apply Loan Amt")]), _vm._v(" "), _c('th', [_vm._v("Member")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Branch Name")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Pre Loan ID")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Pre Loan Total Amount")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Pre Loan Due Amount")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Pre Loan Due Principal Amount")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Pre Loan Due Interest Amount")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Pre Loan Due Forclose Charges")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Pre Loan Discount")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Created By")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-flat btn-xs dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n                      Task "), _c('span', {
    staticClass: "caret"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Dropdown")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Branch "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Member "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "background-color": "#d6dddd"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Select")]), _vm._v(" "), _c('th', [_vm._v("Loan Details ")]), _vm._v(" "), _c('th', [_vm._v("Payment Details")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Date")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("EMI Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "background-color": "#d6dddd"
    }
  }, [_c('tr', [_c('th', [_vm._v("No of EMI ")]), _vm._v(" "), _c('th', [_vm._v("Paid No of EMI")]), _vm._v(" "), _c('th', [_vm._v("Due No of EMI")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("For Close Charge "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Write Off Interest Amount "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("New Loan Amount "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Branch Center"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Staff ID "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Purpose "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Plan "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Description"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Disbursement Loan")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Disbursement Date\n                            "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("EMI Start Date "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                DISBURSEMENT\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                CANCEL\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Loan Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n              CLOSE\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Member Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("C/O")]), _vm._v(" "), _c('th', [_vm._v("Address")]), _vm._v(" "), _c('th', [_vm._v("City")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n              CLOSE\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-630b0c9b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/Loan/LoanTopup.vue
// module id = 857
// module chunks = 0